export const defaultValidationMessages = {
  required: "Dieses Feld ist erforderlich",
  minNumber: (min: number) => `Der Wert muss mindestens ${min} sein`,
  maxNumber: (max: number) => `Der Wert kann höchstens ${max} sein`,
  numbersOnly: "Das Feld muss eine ganze Zahl sein.",
  decimal: "Es sind nur Zahlen mit Dezimalpunkt erlaubt.",
  noEmojis: "Bezeichnung darf keine Emoji beinhalten.",
};